module.exports = __webpack_public_path__ + "img/bg.2fe20007.jpg";